import { render, staticRenderFns } from "./Images.vue?vue&type=template&id=07a6bd48"
import script from "./Images.vue?vue&type=script&lang=js"
export * from "./Images.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07a6bd48')) {
      api.createRecord('07a6bd48', component.options)
    } else {
      api.reload('07a6bd48', component.options)
    }
    module.hot.accept("./Images.vue?vue&type=template&id=07a6bd48", function () {
      api.rerender('07a6bd48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/Images.vue"
export default component.exports